// languages/english.js
export const english = {
  name: "English",
  interface: {
    welcome: "Welcome",
    chooseLanguage: "Choose the language",
    continue: "Continue",
    backToMap: "Back to map",
    achievement: "Achievement",
    viewInAR: "View in AR",
    menu: {
      menu: "Menu",
      home: "Home",
      language: "Language",
      achievement: "Achievement",
      unsuiExperience: "Unsui Experience",
      feedback: "Feedback",
    },
    buyScreen: {
      clickToBuy: "Click to buy a special",
      templeExperience: "Temple experience!",
      description1: "Listen to fascinating stories",
      description2: "about the Temple with an audio guide",
      description3: "and enjoy magical AR!",
      buy: "Buy",
    },
    gift: {
      congratulations: "Congratulations!",
      yourGift: "Your gift",
      giftTitle: "The Supreme Truth",
      giftText: "Check out this amazing gift!",
    },
  },
};
